import { CurrencyAmount } from "../../../utils/currency"

/**
 * Interface for various line item types.
 * The line item type determines what additional data is saved with the line item purchase besides the price,
 * and how that data is collected.
 */
export enum LineItemTypes {
    Donation = 'Donation',
    ForSale = 'ForSale',
    Shirts = 'Shirts'
}

/**
 * Properties common to all lineItemConfigurations
 * dbId: database ID for LineItems
 */
export interface LineItemConfiguration
{
    dbId: number
}

/**
 * Properties for the donation line item type, which saves attribution data.
 * componentName: Name for ID purposes
 * loggedInUserName: Name of logged in user, if necessary.
 */
export interface DonationConfiguration extends LineItemConfiguration 
{
    componentName: string,
    loggedInUserName?: string
}

export interface ForSaleConfiguration extends LineItemConfiguration
{
    componentName: string,
    quantity: number,
    unitPrice: CurrencyAmount
    maximumPermittedInventory: number
    data: ForSaleData
}

export interface ShirtConfiguration extends LineItemConfiguration
{
    componentName: string,
    totalQuantity: number,
    sizeConfiguration: SizeConfiguration[]
}

export interface ShirtData
{
    totalQuantity: number,
    sizes: SizeOrder[]
}

interface SizeConfiguration
{
    dbId: number,
    displayName: string,
    unitPrice: CurrencyAmount,
    maxInventory: number
}

export interface SizeOrder
{
    dbId: number,
    quantity: number,
    unitPrice: CurrencyAmount,
    displayName: string,
    maxInventory: number
}

export interface ForSaleData
{
    registrationAttributions: RegistrationAttributions[]
}

export interface RegistrationAttributions
{
    index: number,
    userId: number,
    target: string,
    customName?: string,
    customEmail?: string
}